import { Divider, Grid, IconButton, Paper, useTheme } from '@mui/material'
import React from 'react'
import { useLocation, useNavigate } from 'react-router-dom'

import ArrowBackIcon from '@mui/icons-material/ArrowBack'
import { theme } from '../../utils/AppColors'
import NoRecordFound from '../NoRecordFound'
import ImageComponent from '../ImageComponent'
import { TextBold, TextRegular } from '../TextStyling'
import { currencySymbol } from '../../utils/AppConstants'
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos'
import { formatNumber } from '../../utils/AppHelper'
import moment from 'moment'

export default function EarningDetails () {
  const location = useLocation()
  const { item, list, payment } = location.state || {}
  const theme = useTheme()
  const navigate = useNavigate()

  const todaysDate = moment() // Today's date as a moment object

  return (
    <Grid container>
      <Grid item xs={12}>
        <Grid
          container
          style={{
            position: 'absolute',
            top: '4rem',
            background: theme.palette.background.paper,
            left: '0px',
            padding: '8px',
            display: 'flex',
            alignItems: 'center'
          }}
        >
          <Grid item>
            <IconButton
              onClick={() =>
                navigate('/recruiter/earningslist ', {
                  state: { rowData: list, payment: payment }
                })
              }
            >
              <ArrowBackIcon style={{ fontSize: '16px' }} />
            </IconButton>
          </Grid>
          <Grid item style={{ marginLeft: '16px' }}>
            Earning details
          </Grid>
        </Grid>
      </Grid>

      <Grid item xs={12} style={{ marginTop: '3rem' }}>
        <Grid container>
          <Grid item xs={12}>
            <Grid
              container
              style={{
                position: 'absolute',
                top: '7rem',
                background: payment
                  ? theme.palette.text.success
                  : item.leftOutDate
                  ? theme.palette.text.error
                  : theme.palette.primary.main,
                left: '0px'
              }}
            >
              <Grid
                item
                xs={12}
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center'
                }}
              >
                <Paper
                  elevation={2}
                  style={{
                    display: 'flex',
                    justifyContent: 'center',
                    width: '46px',
                    borderRadius: '8px',
                    overflow: 'hidden',
                    objectFit: 'contain',
                    alignItems: 'center',
                    background: theme.palette.background.paper,
                    margin: '8px'
                  }}
                >
                  <ImageComponent
                    alt='company logo'
                    src={item.profilePicture}
                    style={{ width: '100%' }}
                  />
                </Paper>
              </Grid>
              <Grid container style={{ padding: '16px' }}>
                <Grid
                  item
                  xs={5.9}
                  style={{ display: 'flex', flexDirection: 'column' }}
                >
                  <TextRegular
                    style={{ color: theme.palette.background.paper }}
                  >
                    {item.transactionId && <>Transaction ID</>}
                    {item.leftOutDate && <>Employee leftout</>}
                    {item.dueOn &&
                      !item.leftOutDate &&
                      item.transactionId === '' && <>Due Date</>}
                  </TextRegular>
                  <TextRegular
                    style={{ color: theme.palette.background.paper }}
                  >
                    {item.transactionId && item.transactionId}
                    {item.leftOutDate &&
                      moment(item.leftOutDate).format('MMMM Do YYYY')}
                    {item.dueOn &&
                      !item.leftOutDate &&
                      item.transactionId === '' &&
                      moment(item.dueOn).format('MMMM Do YYYY')}
                  </TextRegular>
                </Grid>
                <Grid item xs={0.1}>
                  <TextRegular
                    style={{ color: theme.palette.background.paper }}
                  >
                    :
                  </TextRegular>
                </Grid>
                <Grid
                  item
                  xs={5.9}
                  style={{
                    display: 'flex',
                    alignItems: 'end',
                    flexDirection: 'column'
                  }}
                >
                  <TextRegular
                    style={{ color: theme.palette.background.paper }}
                  >
                    {item.transactionId && <>Earned</>}
                    {item.leftOutDate && <>Not earning</>}
                    {item.dueOn &&
                      !item.leftOutDate &&
                      item.transactionId === '' && <>To be earn</>}
                  </TextRegular>
                  <TextBold style={{ color: theme.palette.background.paper }}>
                    {currencySymbol}
                    {item.dueOn &&
                      (!item.leftOutDate || item.leftOutDate) &&
                      item.transactionId === '' &&
                      formatNumber(item.amountToPay)}
                    {item.transactionId && formatNumber(item.amountPaid)}
                  </TextBold>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
          <Grid item xs={12}>
            <Grid
              container
              style={{
                position: 'absolute',
                marginTop: '7rem',
                background: theme.palette.background.paper,
                left: '0px',
                // height: '58%',
                padding: '16px'
              }}
            >
              <Grid
                item
                xs={12}
                style={{
                  display: 'flex',
                  flexDirection: 'column',
                  padding: '4px'
                }}
              >
                <TextRegular
                  style={{
                    color: theme.palette.text.disabled,
                    fontSize: '12px'
                  }}
                >
                  {item.jobTitle}
                </TextRegular>
                <TextRegular>
                  {item.candidateFirstName} {item.candidateLastName}
                </TextRegular>
              </Grid>
              <Grid container style={{ marginTop: '8px' }}>
                <Grid
                  item
                  xs={6}
                  style={{
                    display: 'flex',
                    flexDirection: 'column',
                    padding: '4px'
                  }}
                >
                  <TextRegular
                    style={{
                      color: theme.palette.text.disabled,
                      fontSize: '12px'
                    }}
                  >
                    Joining date:
                  </TextRegular>
                  <TextRegular>
                    {moment(item.joiningDate).format('MMMM Do YYYY')}
                  </TextRegular>
                </Grid>

                <Grid
                  item
                  xs={6}
                  style={{
                    display: 'flex',
                    flexDirection: 'column',
                    padding: '4px'
                  }}
                >
                  <TextRegular
                    style={{
                      color: theme.palette.text.disabled,
                      fontSize: '12px'
                    }}
                  >
                    Guarantee Period:
                  </TextRegular>
                  <TextRegular>
                    {moment(item.guaranteePeriodEndDate).format('MMMM Do YYYY')}
                  </TextRegular>
                </Grid>

                <Grid
                  item
                  xs={6}
                  style={{
                    display: 'flex',
                    flexDirection: 'column',
                    padding: '4px'
                  }}
                >
                  <TextRegular
                    style={{
                      color: theme.palette.text.disabled,
                      fontSize: '12px'
                    }}
                  >
                    Due On:
                  </TextRegular>
                  <TextRegular>
                    {moment(item.dueOn).format('MMMM Do YYYY')}
                  </TextRegular>
                </Grid>
              </Grid>

              <Grid container style={{ marginTop: '8px' }}>
                <Grid
                  item
                  xs={6}
                  style={{
                    display: 'flex',
                    flexDirection: 'column',
                    padding: '4px'
                  }}
                >
                  <TextRegular
                    style={{
                      color: theme.palette.text.disabled,
                      fontSize: '12px'
                    }}
                  >
                    Applied on:
                  </TextRegular>
                  <TextRegular>
                    {moment(item.appliedOn).format('MMMM Do YYYY')}
                  </TextRegular>
                </Grid>

                <Grid
                  item
                  xs={6}
                  style={{
                    display: 'flex',
                    flexDirection: 'column',
                    padding: '4px'
                  }}
                >
                  <TextRegular
                    style={{
                      color: theme.palette.text.disabled,
                      fontSize: '12px'
                    }}
                  >
                    Manager review date:
                  </TextRegular>
                  <TextRegular>
                    {moment(item.managerReviewDate).format('MMMM Do YYYY')}
                  </TextRegular>
                </Grid>

                <Grid
                  item
                  xs={6}
                  style={{
                    display: 'flex',
                    flexDirection: 'column',
                    padding: '4px'
                  }}
                >
                  <TextRegular
                    style={{
                      color: theme.palette.text.disabled,
                      fontSize: '12px'
                    }}
                  >
                    Hired on:
                  </TextRegular>
                  <TextRegular>
                    {moment(item.hiredOnDate).format('MMMM Do YYYY')}
                  </TextRegular>
                </Grid>

                <Grid
                  item
                  xs={6}
                  style={{
                    display: 'flex',
                    flexDirection: 'column',
                    padding: '4px'
                  }}
                >
                  <TextRegular
                    style={{
                      color: theme.palette.text.disabled,
                      fontSize: '12px'
                    }}
                  >
                    Base salary:
                  </TextRegular>
                  <TextRegular>
                    {currencySymbol}
                    {formatNumber(item.baseSalary)}
                  </TextRegular>
                </Grid>

                <Grid
                  item
                  xs={6}
                  style={{
                    display: 'flex',
                    flexDirection: 'column',
                    padding: '4px'
                  }}
                >
                  <TextRegular
                    style={{
                      color: theme.palette.text.disabled,
                      fontSize: '12px'
                    }}
                  >
                    Joining status:
                  </TextRegular>

                  {item.isJoined === 1 ? (
                    <TextRegular style={{ color: theme.palette.text.success }}>
                      Joined
                    </TextRegular>
                  ) : (
                    <TextRegular style={{ color: theme.palette.text.error }}>
                      Not joined
                    </TextRegular>
                  )}
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  )
}
